import React, { useState } from "react";
import { Select, Modal } from "antd";
import { useTranslation } from "react-i18next";

const { Option } = Select;

const LANGUAGES = [
  { value: "pt", flagSprite: "portugal", localName: "Português" },
  { value: "en", flagSprite: "unitedkingdom", localName: "English" },
];

const LanguageSelector = ({ className = "language-selector", style, variant = "select", customStyle }) => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  // Producer accent for borders (falls back to a neutral gray).
  const accent = customStyle?.primary?.backgroundColor || customStyle?.link?.linkColor || "#9aa6b6";

  // Flag-only button that opens a modal with the language choices (mobile).
  if (variant === "button") {
    const current = LANGUAGES.find((l) => l.value === i18n.resolvedLanguage) || LANGUAGES[0];
    return (
      <>
        <button
          type="button"
          className={`lang-flag-button ${className}`}
          style={{ ...style, "--lang-accent": accent }}
          onClick={() => setOpen(true)}
          aria-label={current.localName}
        >
          <span className={`flag-sprite-small flag-sprite-${current.flagSprite}`} />
        </button>
        <Modal open={open} visible={open} footer={null} closable centered width={300} title={t("language.modalTitle")} onCancel={() => setOpen(false)}>
          <div className="lang-options" style={{ "--lang-accent": accent }}>
            {LANGUAGES.map((lang) => (
              <button
                key={lang.value}
                type="button"
                className={`lang-option ${lang.value === current.value ? "lang-option-active" : ""}`}
                onClick={() => {
                  i18n.changeLanguage(lang.value);
                  setOpen(false);
                }}
              >
                <span className={`flag-sprite-small flag-sprite-${lang.flagSprite}`} style={{ marginRight: 10 }} />
                {lang.localName}
              </button>
            ))}
          </div>
        </Modal>
      </>
    );
  }

  return (
    <Select
      className={className}
      size="small"
      value={i18n.resolvedLanguage}
      onChange={(lng) => i18n.changeLanguage(lng)}
      style={{ ...style, "--lang-accent": accent }}
    >
      {LANGUAGES.map((lang) => (
        <Option key={lang.value} value={lang.value} label={lang.localName}>
          <span className={`flag-sprite-small flag-sprite-${lang.flagSprite}`} style={{ marginRight: 5 }} />
          {lang.localName}
        </Option>
      ))}
    </Select>
  );
};

export default LanguageSelector;
